<template>
    <div>
        <!-- Outgoing Call Dialog -->
        <Dialog v-model:visible="showOutgoingCall" modal :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '400px' }">
            <template #header>
                <h3><img :src="$utils.getAvatar(remoteUserAvatar)" class="avatar_call" /> {{
            $t('callMessages.outgoingCallTitle', {
                remoteUserName
            }) }}</h3>
            </template>
            <template #default>
                <div class="call-dialog-content">
                    <p>{{ $t('callMessages.outgoingCallWait') }}</p>
                    <Button :label="$t('callMessages.cancel')" @click="cancelOutgoingCall" />
                </div>
            </template>
        </Dialog>

        <!-- Incoming Call Dialog -->
        <Dialog v-model:visible="showIncomingCall" :modal="false" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '400px' }">
            <template #header>
                <h3><img :src="$utils.getAvatar(callerUser.avatar)" class="avatar_call" /> {{ callerUser.nickname }} {{
            $t('callMessages.incomingCallTitle') }}</h3>
            </template>
            <template #default>
                <div class="call-dialog-content">
                    <p>{{ $t('callMessages.incomingCallMessage') }}</p>
                    <div class="call-dialog-buttons">
                        <Button :label="$t('callMessages.accept')" class="p-button-success" @click="acceptCall" />
                        <Button :label="$t('callMessages.reject')" class="p-button-danger" @click="rejectCall" />
                    </div>
                </div>
            </template>
        </Dialog>

        <!-- Call Active Dialog -->

        <Dialog v-model:visible="callActive" modal :header="$t('callMessages.callWithUser', { remoteUserName })"
            :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" @hide="endCall">
            <div id="call-container"></div>
        </Dialog>

    </div>
    <Toast />
</template>

<script>

export default {
    props: ['conversations'],
    emits: ['startSession', 'endSession'],
    data() {
        return {
            currentCallIsVideo: false,
            remoteUserId: null,
            remoteUserName: null,
            remoteUserAvatar: null,
            callerId: null,
            callerUser: null,
            callActive: false,
            showOutgoingCall: false,
            showIncomingCall: false,
            liveKitRoom: null,
            localTracks: [],
            
        };
    },
    methods: {
        async startCall(targetUser, isVideoCall) {
            this.currentCallIsVideo = isVideoCall;
            const hasPermission = await this.checkMediaPermissions();
            if (!hasPermission) {
                return;
            }

            this.remoteUserId = targetUser.user_id;
            this.remoteUserName = targetUser.name;
            this.remoteUserAvatar = targetUser.avatar;
            this.showOutgoingCall = true;

            this.$socket.emit('call-user', {
                to: targetUser.user_id,
                isVideoCall,
            });
        },
        cancelOutgoingCall() {
            this.$socket.emit('cancel-call', { to: this.remoteUserId });
            this.showOutgoingCall = false;
        },
        async acceptCall() {
            const hasPermission = await this.checkMediaPermissions();
            if (!hasPermission) {
                this.rejectCall('no-permission');
                return;
            }

            this.$socket.emit('call-accepted', {
                to: this.callerId,
            });

            this.remoteUserId = this.callerId;
            this.remoteUserName = this.callerUser.nickname;
            this.remoteUserAvatar = this.callerUser.avatar;
            this.showIncomingCall = false;
        },
        rejectCall(reason = 'rejected') {
            this.$socket.emit('call-rejected', {
                to: this.callerId,
                reason,
            });

            this.showIncomingCall = false;
            const t = this.$t;
            if (reason === 'rejected') {
                this.$toast.add({
                    severity: 'info',
                    summary: t('callMessages.callRejectedYouRejected'),
                    detail: t('callMessages.callRejectedYouRejected'),
                });
            }
        },
        async endCall() {
            if (this.liveKitRoom) {
                this.liveKitRoom = null;
            }
            this.$socket.emit('call-ended', { to: this.remoteUserId });

            this.callActive = false;
            this.remoteUserId = null;
            this.remoteUserName = null;
            this.remoteUserAvatar = null;
        },
        /*
        async startLiveKitSession(token) {

            this.$emit('startSession', token, this.currentCallIsVideo , this.remoteUserId);


            this.liveKitRoom = true;
            this.callActive = true;

            const iframeContent = `<!doctype html>
            <html lang="en">
            <head>
                <meta charset="utf-8" />
                <link rel="icon" href="/favicon.ico" />
                <meta name="viewport" content="width=device-width,initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <script defer src="https://cdn1.easychatrooms.com/assets/livekit/static/js/main.js?timestamp=${Date.now()}"></` + `script>
                <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/main.css" rel="stylesheet">
                <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/custom.css?timestamp=${Date.now()}" rel="stylesheet">
            </head>
            <body>
                <noscript>You need to enable JavaScript to run this app.</noscript>
                <div id="root"></div>
                <script>
                    window.WStoken = "${token}";
                    window.WSurl = "wss://easychatrooms-89sotbya.livekit.cloud";
                    window.WSAudio = true;
                    window.WSVideo = ${this.currentCallIsVideo};
                    window.WSIsConferanceRoom = true;
                </` + `script>
            </body>
            </html>`;


            setTimeout(() => {
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none';
                iframe.style.borderRadius = '10px';
                iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
                iframe.srcdoc = iframeContent;

                document.getElementById('call-container').innerHTML = '';
                document.getElementById('call-container').appendChild(iframe);
            }, 1000);


        },*/

        async checkMediaPermissions() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: this.currentCallIsVideo, audio: true });
                stream.getTracks().forEach(track => track.stop());
                return true;
            } catch (err) {
                const t = this.$t;
                this.$toast.add({
                    severity: 'error',
                    summary: t('callMessages.accessDeniedTitle'),
                    detail: t('callMessages.accessDeniedMessage'),
                });
                return false;
            }
        },
    },
    mounted() {
        const t = this.$t;
        this.$socket.on('call-made', (data) => {

            if (!this.conversations.find(c => (c.user_id === data.from && c.private))) {
                this.$socket.emit('call-rejected', {
                    to: data.from,
                    reason: 'not-found', 
                })  
                return;
            }


            if (this.callActive || this.showIncomingCall) {
                this.$socket.emit('call-rejected', {
                    to: data.from,
                    reason: 'busy',
                });
                return;
            }

            // Set incoming call states
            this.callerId = data.from;
            this.callerUser = data.caller;
            this.showIncomingCall = true;
            this.currentCallIsVideo = data.isVideoCall || false;
        });

        this.$socket.on('call-accepted', (data) => {
            this.$emit('startSession', data, this.currentCallIsVideo , this.remoteUserId);
            this.showOutgoingCall = false;
        });

        this.$socket.on('call-rejected', (data) => {

            this.showOutgoingCall = false;

            let message = t('callMessages.callRejectedMessage');
            if (data.reason === 'busy') {
                message = t('callMessages.callRejectedUserBusy');
            } else if (data.reason === 'no-permission') {
                message = t('callMessages.callRejectedNoPermission');
            } else if (data.reason === 'no-answer') {
                message = t('callMessages.callRejectedNoAnswer');
            } else if (data.reason === 'not-found') {
                message = t('callMessages.conversationNotFound');
            }

            this.$toast.add({
                severity: 'warn',
                summary: t('callMessages.callRejectedTitle'),
                detail: message,
            });
        });

        this.$socket.on('call-ended', () => {
            if (this.liveKitRoom) {
                this.liveKitRoom = null;
            }

            this.$emit('endSession', this.remoteUserId);

            this.callActive = false;
            this.remoteUserId = null;
            this.remoteUserName = null;

            this.$toast.add({
                severity: 'info',
                summary: t('callMessages.callEndedTitle'),
                detail: t('callMessages.callEndedMessage'),
            });
        });

        this.$socket.on('cancel-call', () => {
            // Incoming call cancelled
            this.showIncomingCall = false;
            this.$toast.add({
                severity: 'info',
                summary: t('callMessages.callCancelledTitle'),
                detail: t('callMessages.callCancelledMessage'),
            });
        });
    },
};
</script>

<style scoped>
.call-dialog-content {
    text-align: center;
}

.call-dialog-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
}

.avatar_call {
    height: 32px;
    width: 32px;
    border-radius: 50%;
}

@media screen and (max-width: 640px) {
    .local-video-container {
        width: 100px;
        height: 75px;
    }

    .end-call-button {
        bottom: 0.5rem;
    }
}

.p-dialog h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

#call-container {
    width: 100%;
    height: 100%;
    min-height: 500px;
    position: relative;
}

iframe {
    border: none;
    border-radius: 10px;
}


</style>